export default __webpack_public_path__ + "static/video0-404426ebf352e8d1d212f0efde5daada.webm";